<template>
  <div>
    <b-row>
      <b-col md="12" class="hide-label">
        <InputTextArea
          class="mb-4"
          type="text"
          textFloat="Text"
          placeholder=""
          name="text"
          rows="5"
          isRequired
          v-model="response.content.Text.Text"
          :isValidate="v.content.Text.Text.$error"
          :v="v.content.Text.Text"
          :textOption="response.content.Text"
        />
      </b-col>
      <b-col md="12">
        <span class="text-main-color f-size-16 font-weight-bold">Image</span>
      </b-col>
      <b-col md="12">
        <ImageUpload
          class="mt-1"
          v-bind:dataFile="response.content.Image"
          :v="v.content.Image.ImageUrl"
          @handleChangeImage="handleChangeImage"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="">
        <div class="d-flex">
          <div>
            <span class="text-main-color f-size-16">Options</span>
          </div>
          <div class="ml-auto  " @click="addButtonResponseOptions">
            <u class="pointer text-blue">Add</u>
          </div>
        </div>
        <div class="mt-2">
          <div
            v-for="(button, bindex) in response.content.Button"
            :key="bindex"
            class="p-3 button-box mb-2"
          >
            <div class="d-flex">
              <div class="f-size-16 text-main-color">
                Option # {{ bindex + 1 }}
              </div>
              <div class="ml-auto" v-if="response.content.Button.length > 1">
                <font-awesome-icon
                  @click="onDeleteButtonOption(bindex)"
                  icon="trash-alt"
                  class="pointer"
                  color="#ffffff"
                />
              </div>
            </div>
            <div class="mt-3">
              <ButtonResponseOptionForm
                class="button-form"
                :button="button"
                :v="v.content.Button.$each.$iter[bindex]"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import ImageUpload from "@/views/pages/flow-builder/components/sidebar/ImageUpload";
import ButtonResponseOptionForm from "@/views/pages/flow-builder/components/sidebar/ButtonResponseOptionForm";
export default {
  components: {
    ImageUpload,
    InputTextArea,
    ButtonResponseOptionForm,
  },
  props: {
    response: {
      required: true,
      type: Object,
    },
    v: {
      required: false,
      type: Object,
    },
  },
  methods: {
    handleChangeImage(image) {
      this.response.content.Image.ImageUrl = image;
    },
    onDeleteButtonOption(index) {
      this.response.content.Button.splice(index, 1);
      this.response.content.Button.forEach((element, bindex) => {
        element.SortOrder = bindex + 1;
      });
    },
    scrollToEnd: function() {
      var container = document.getElementsByClassName("button-form");
      setTimeout(() => {
        container[container.length - 1].scrollIntoView(false);
      }, 0);
    },
    addButtonResponseOptions() {
      const body = {
        Id: 0,
        Title: "",
        Payload: "",
        ButtonTypeId: 1,
        WebviewSize: null,
        SortOrder: this.response.content.Button.length + 1,
      };

      this.response.content.Button.push(body);
      this.scrollToEnd();
    },
  },
};
</script>

<style lang="scss" scoped>
.button-box {
  background-color: #cdcae2;
  border-radius: 6px;
}
</style>
